
// Responsive images and lazy loading
import lazySizes from 'lazysizes';
lazySizes.cfg.addClasses = true;
lazySizes.cfg.preloadAfterLoad = true;
lazySizes.cfg.lazyClass = 'lazyload';
lazySizes.cfg.preloadClass = 'lazypreload';
lazySizes.cfg.loadingClass = 'lazyloading';
lazySizes.cfg.loadedClass = 'lazyloaded';

// replace no-js class with js class
(function (h) {
    h.className = h.className.replace('no-js', 'js');
})(document.documentElement);

function onContentLoaded(callback) {
    if (document.readyState == "complete" || document.readyState == "loaded") {
        callback(); return;
    }
    if (window.addEventListener)
        window.addEventListener('DOMContentLoaded', callback, false);
    else if (window.attachEvent)
        window.attachEvent('onload', callback);
    else window.onload = callback;
}

function onScriptsLoaded(callback) {
    if (window.initialScriptsLoaded === true) {
        callback(); return;
    }
    if (window.addEventListener) {
        window.addEventListener('initialScriptsLoaded', callback, false);
        return;
    }
    //if (window.console) console.error('addEventListener not supported');
    return;
}

// fallback: show unstyled content if the main stylesheet hasn't been loaded for 3s
setTimeout(function () {
    document.body.style.visibility = 'visible';
    document.body.style.opacity = '1';
}, 3 * 60 * 1000);


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *	CSS Masks
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
// Check if clip-path is supported. From http://stackoverflow.com/a/30041538.
function ClipPathSupported() {
    var base = 'clipPath',
        prefixes = [],
        properties = [base],
        testElement = document.createElement('testelement'),
        attribute = 'polygon(50% 0%, 0% 100%, 100% 100%)',
        l,
        i;
    // Push the prefixed properties into the array of properties.
    for (i = 0, l = prefixes.length; i < l; i++) {
        var prefixedProperty = prefixes[i] + base.charAt(0).toUpperCase() + base.slice(1); // remember to capitalize!
        properties.push(prefixedProperty);
    }

    // Interate over the properties and see if they pass two tests.
    for (i = 0, l = properties.length; i < l; i++) {
        var property = properties[i];

        // First, they need to even support clip-path (IE <= 11 does not)...
        if (testElement.style[property] === '') {

            // Second, we need to see what happens when we try to create a CSS shape...
            testElement.style[property] = attribute;
            if (testElement.style[property] !== '') {

                return true;
            }
        }
    }

    return false;
}

/*
 * We're transforming a  data-mask="3,0,-3,0"  attribute into a inlined SVG that we use as a clip path
 */
var cssMaskCount = 1;
if (ClipPathSupported()) {
    // add class to header for supported clip-path
    if (document.documentElement.classList) {

        document.documentElement.classList.add('css-mask-supported');
    } else {

        document.documentElement.className += ' ' + 'css-mask-supported';
    }

    // add parsing function
    parseCssMasks();

    window.addEventListener('resize', () => {
        //console.log('calling parseCssMasks() due resize');
        parseCssMasks();
    });

    const accordionLiCheck = document.querySelectorAll('.accordion > li > input[type="checkbox"]');

    if (accordionLiCheck.length > 0) {

        accordionLiCheck.forEach((accordionLiCheck) => {
            accordionLiCheck.addEventListener('click', (event) => {
                setTimeout(function () { parseCssMasks(); }, 1250);
            });
        });
    }

    const printButtons = document.querySelectorAll('a[href="javascript:window.print()"]');

    if (printButtons.length > 0) {

        printButtons.forEach((printButtons) => {
            printButtons.addEventListener('click', (event) => {
                parseCssMasks();
            });
        });
    }

}

function parseCssMasks() {

    //$('[data-mask]').each(function(i) {
    var elements = document.querySelectorAll('[data-mask]');
    //if (window.console) console.log('Found ' + elements.length + ' elements with css mask');
    for (var i = 0; i < elements.length; i++) {


        var el = elements[i];
        cssMaskCount = i + 1;

        // get attribute value and split on comma
        var angles = el.getAttribute('data-mask').split(','); //$(this).data('mask').split(',');

        //console.log(angles);

        if (angles[0] === '0' && angles[1] === '0' && angles[2] === '0' && angles[3] === '0') continue;

        // unset previous clip path
        el.style['clip-path'] = 'none';
        // el.style['-webkit-clip-path'] = 'none';

        // get element height
        var height = el.offsetHeight; //$(this).height();
        var width = el.offsetWidth; //(window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);

        // get child width for "image--fullwidth" (to make container wider in firefox)
        if (el.classList && el.classList.contains('image--fullwidth')) {

            //console.log('contians image--fullwidth');
            width = el.querySelectorAll('img')[0].offsetWidth;
        }

       // console.log({height}, {i});

        // calculate left and right positions:
        var topleft = [0, 0];
        var topright = [width, 0];
        var bottomleft = [0, height];
        var bottomright = [width, height];
        var difference = 0;
        var topdifference = 0;
        var bottomdifference = 0;

        // top angle
        if (angles[0] !== undefined) {

            //console.log('angles 0 is defined');
            difference = topdifference = Math.round(width * Math.tan(Math.abs(angles[0]) * Math.PI / 180));
            if (difference > height) difference = height;
            if (angles[0] > 0) {
                topleft[1] = topleft[1] + difference;
            } else {
                topright[1] = topright[1] + difference;
            }
        }

        // right angle
        if (angles[1] !== undefined) {
            difference = Math.round(width * Math.tan(Math.abs(angles[1]) * Math.PI / 180));
            if (difference > width) difference = width;
            if (angles[1] > 0) {
                bottomright[0] = bottomright[0] - difference;
            } else {
                topright[0] = topright[0] - difference;
            }
        }

        // bottom angle
        if (angles[2] !== undefined) {
            difference = bottomdifference = Math.round(width * Math.tan(Math.abs(angles[2]) * Math.PI / 180));
            if (difference > height) difference = height;
            if (angles[2] > 0) {
                bottomright[1] = bottomright[1] - difference;
            } else {
                bottomleft[1] = bottomleft[1] - difference;
            }
        }

        // left angle
        if (angles[3] !== undefined) {
            difference = Math.round(width * Math.tan(Math.abs(angles[3]) * Math.PI / 180));
            if (difference > width) difference = width;
            if (angles[3] > 0) {
                topleft[0] = topleft[0] + difference;
            } else {
                bottomleft[0] = bottomleft[0] + difference;
            }
        }

        // generate polygon points / path
        var svgPolygonPoints = [
            topleft.join(' '),
            topright.join(' '),
            bottomright.join(' '),
            bottomleft.join(' ')
        ]; //'0 '+topleft+', '+width+' '+topright+', '+width+' '+bottomleft+', 0 '+bottomright;

        //console.log('creating mask for', el, 'width: '+width, 'height '+height, svgPolygonPoints);

        // remove any previous svg with that id
        var oldsvg = document.getElementById('svg-clip-' + cssMaskCount);
        if (oldsvg !== null) oldsvg.parentNode.removeChild(oldsvg);

        // svg needs to be created with correct namespace
        var _svgNS = 'http://www.w3.org/2000/svg';

        var svg = document.createElementNS(_svgNS, 'svg');
        svg.setAttributeNS(null, 'width', '0');
        svg.setAttributeNS(null, 'height', '0');
        svg.setAttributeNS(null, 'id', 'svg-clip-' + cssMaskCount);
        //svg.setAttributeNS(null, 'class', 'show-for-sr');

        // add <defs> element
        var defs = document.createElementNS(_svgNS, 'defs');
        svg.appendChild(defs);

        // add <clipPath>
        var clippath = document.createElementNS(_svgNS, 'clipPath');
        clippath.setAttributeNS(null, 'id', 'clip-' + cssMaskCount);
        defs.appendChild(clippath);

        // add <polygon>
        var polygon = document.createElementNS(_svgNS, 'polygon');
        polygon.setAttributeNS(null, 'points', svgPolygonPoints);
        clippath.appendChild(polygon);

        // append svg to body
        document.getElementById('svgcontainer').appendChild(svg);

        //$("body").append(svg);
        //$(this).css('clip-path', 'url(#clip-' + (i+1) +')').addClass('css-mask-applied');

        // add clip-path style to element
        el.style['clip-path'] = 'url(#clip-' + cssMaskCount + ')';
        //el.style['-webkit-clip-path'] = 'url(#clip-' + cssMaskCount +')';
        cssMaskCount++;

        // prevent cross browser issues
        if (el.className === undefined) el.className = '';

        // adjust margin-bottom for background-rows
        if (el.classList && el.classList.contains('row-background')) {
            el.style['margin-top'] = (topdifference * -1) + 'px';
            el.style['margin-bottom'] = (bottomdifference * -1) + 'px';
        } else if (el.className.indexOf('row-background') > -1) {
            el.style['margin-top'] = (topdifference * -1) + 'px';
            el.style['margin-bottom'] = (bottomdifference * -1) + 'px';
        }

        // add css class to element
        if (el.classList) {
            el.classList.add('css-mask-applied');
        } else {
            el.className += ' ' + 'css-mask-applied';
        }

    }

};

// disable video for "reduced motion" clients
var bgvid = document.getElementById("bgvid");
if (bgvid && window.matchMedia('(prefers-reduced-motion)').matches) {
    bgvid.removeAttribute("autoplay");
    bgvid.pause();
}
